import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    const titulo = process.env.REACT_APP_SITE_TITLE || "Cursos";
    return (
        <header className="navbar">
            <Link to="/" className="navbar-brand">
                <span className="navbar-brand-mark">{titulo.charAt(0)}</span>
                {titulo}
            </Link>
        </header>
    );
};

export default Navbar;
